/**
 * Hook that triggers re-renders when signed URLs arrive from the batch cache.
 *
 * Call this at the top of any component that displays images via
 * previewUrl(), faceCropUrl(), or signedSrc().
 */

import { useEffect, useState } from 'react'
import { subscribe } from './signedUrlCache'
import { AUTH_ENABLED } from '@/auth/config'

export function useSignedUrls(): void {
  const [, bump] = useState(0)
  useEffect(() => {
    if (!AUTH_ENABLED) return
    return subscribe(() => bump((n) => n + 1))
  }, [])
}
